import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useTranslation } from "react-i18next";
import DashboardPagesTemplate from "../../Template/DashboardPagesTemplate";
import DashboardPageTitle from "../../Components/InnerPageTitle";

import CopyWidgetScriptCode from "../../Components/ScriptCode";
import PlatformInstallationGuidelines from "../../Components/Platforms/PlatformInstallationGuidelines";
import TourGuide from "../../Components/TourGuide";
import AccessibilityChecker from "../../Components/AccessibilityChecker";

// component to render integration scripts page
const AccessibilityCheckerPage = () => {

  // Redux Data
  const { currentWebsite } = useSelector((store: StoreProptypes) => store);

  // Functions
  const { t } = useTranslation();

  return (
    <>
      <DashboardPagesTemplate>
      <TourGuide />
        <DashboardPageTitle
          pageTitle={`${t("accessibility checker")}`}
        />

        <AccessibilityChecker />
      </DashboardPagesTemplate>

    </>
  )
}

export default AccessibilityCheckerPage;
